<div class="auth-v2">
    <div class="auth-inner row m-0">
        <!-- Login-->
        <div class="d-flex col-12 align-items-center auth-bg p-1 p-lg-5">
            <div class="col-12 px-xl-2 mx-auto">
                <h2 class="card-title font-weight-bold mb-1">Welcome to Alpha Trend! 👋</h2>
                <p class="card-text mb-2">Please sign-in to your account and start the adventure</p>
                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>
                <div class="row">
                    <div class="col-lg-6 col-12 nft-section p-lg-2">
                        <p class="card-text mb-2">To access NFTS</p>
                        <div class="mt-3">
                            <app-wallat-connect (walletConnected)="isWalletConnet($event)"></app-wallat-connect>
                            <div class="divider mb-2">
                                <hr>
                            </div>
                            <p class="text-center mt-2" (click)="modalService.dismissAll()">
                                <span>Do not have a wallet yet?</span>
                                <a (click)="installMetaMask()" class="text-primary">
                                    <span>&nbsp;click here to get a Metamask wallet.</span>
                                </a>
                            </p>
                            <div class="divider mb-2 d-lg-none">
                                <hr>
                            </div>
                        </div>
                    </div>
                    <!--   -->
                    <div class="col-lg-6 col-12 p-lg-2">
                        <p class="card-text mb-2">To Login</p>
                        <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label class="form-label" for="login-email">Email</label>
                                <input type="text" formControlName="email" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" placeholder=""
                                    aria-describedby="login-email" autofocus="" tabindex="1" />
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div *ngIf="f.email.errors.required">Email is required</div>
                                    <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="d-flex justify-content-between">
                                    <label for="login-password">Password</label><a
                                        routerLink="/forgot-password" (click)="modalService.dismissAll()"><small>Forgot
                                            Password?</small></a>
                                </div>
                                <div class="input-group input-group-merge form-password-toggle">
                                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
                                        class="form-control form-control-merge"
                                        [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                                        placeholder="············" aria-describedby="login-password" tabindex="2" />
                                    <div class="input-group-append">
                                        <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                            'icon-eye-off': passwordTextType,
                            'icon-eye': !passwordTextType
                          }" (click)="togglePasswordTextType()"></i></span>
                                    </div>
                                </div>
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback"
                                    [ngClass]="{ 'd-block': submitted && f.password.errors }">
                                    <div *ngIf="f.password.errors.required">Password is required</div>
                                </div>
                            </div>
                            <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="3" rippleEffect>
                                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Sign in
                            </button>
                        </form>
                        <div class="divider my-2">
                            <hr>
                        </div>
                        <p class="text-center mt-2" (click)="modalService.dismissAll()">
                            <span>New on our platform?</span><a
                                routerLink="/register"><span>&nbsp;Create an account</span></a>
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <!-- /Login-->
    </div>
</div>